import React, { useEffect, useState } from 'react'
import ArchitectureExperienceComponent from '../Components/ArchitectureExperienceComponent';
import AdminHeaderComponent from '../Components/AdminHeaderComponent';
import { workStyleResponse } from '../Types/AdminType';
import { getAllWorkStyle } from '../Services/AdminService';
import WorkStyleComponent from '../Components/WorkStyleComponent';


function WorkStylePage() {
 const [adminData, setAdminData] = useState<workStyleResponse []>([]);
      const [loading, setLoading] = useState<boolean>(true);
      const [error, setError] = useState<string>("");
      
      useEffect(() => {
        const fetchCandidate = async () => {
          try {
            setLoading(true); // Ensure loading is true when starting
            const response = await getAllWorkStyle();
  
            console.log("Recruiters Response:", response);
      
            if (response.success) {
              setAdminData(response.data);
            } else {
              setError(response.message || "Could not retrieve recruiter profile.");
            }
          } catch (err) {
            setError("An unexpected error occurred while loading the profile.");
            console.error(err);
          } finally {
            setLoading(false);
          }
        };
      
        fetchCandidate();
      }, []); // Empty dependency array is fine if using localStorage
  
  
      const handleEdit = () => {
        // Implement the logic to edit the recruiter with the given ID and updated data
        console.log(`Edit recruiter with ID:` );
      }
  
      const handleDelete = (id: string) => {
        // Implement the logic to delete the recruiter with the given ID
        console.log(`Delete recruiter with ID: ${id}`);
      }

  return (
    <div>
      {/* <AdminHeaderComponent /> */}
      <WorkStyleComponent
       data={adminData} 
          onEditSubmit={handleEdit} 
          onDeleteConfirm={handleDelete} 
          onRegisterSubmit={handleEdit}
          menuName="Work Style"/>
    </div>
  )
}

export default WorkStylePage